import ParamMaker from '@/utils/modules/ParamMaker'
import axios from '@/services/axiosConfig'

const endPoint = {
	getUnit: unit => `/unit?value=${unit}`,
	lookupInventoryList: instId => `/institute/${instId}/inventory/list`,
	lookupWaitingList: (
		instId,
		offset = 0,
		length = 30,
		status = '',
		categoriesType = ['CAT_CHEMICAL_REAGENT'],
		registersId = [],
		startDatetime,
		endDatetime
	) => {
		let parameter = `/institute/${instId}/inspect/list?offset=${offset}&length=${length}&status=${status}`
		if (categoriesType.length != 0)
			parameter += `&${ParamMaker.setArrayString(
				'categoriesType',
				categoriesType
			)}`
		if (registersId & (registersId.length != 0))
			parameter += `&${ParamMaker.setArrayString(
				'registersId',
				registersId
			)}`
		if ((startDatetime != undefined) & (endDatetime != undefined))
			parameter += `&startDatetime=${startDatetime}&endDatetime=${endDatetime}`
		return parameter
	},
	lookupInventoryListV2: instId => `/institute/${instId}/inventory/list`,
	lookupItemDetail: (instId, itemId) =>
		`/institute/${instId}/inventory?id=${itemId}`,
	useItem: instId => `/institute/${instId}/inventory/hold`,
	returnItem: instId => `/institute/${instId}/inventory/return`,
	deleteItem: (instId, itemIds, memo) =>
		`/institute/${instId}/inventory?${ParamMaker.setArrayString(
			'itemsId',
			itemIds
		)}&memo=${memo}`,
	disposeItem: instId => `/institute/${instId}/inventory/dispose`,
	consumeItem: instId => `/institute/${instId}/inventory/consume`,
	lookupInventoryAssignees: instId =>
		`/institute/${instId}/inventory/assignees`,
	lookupCategory: instId => `/institute/${instId}/category/list`,
	divideItem: instId => `/institute/${instId}/inventory/subdivide`,
	moveStorage: instId => `/institute/${instId}/inventory/storage`,
	searchProduct: instId => `/institute/${instId}/inventory/product/search`,
	searchIngredient: instId =>
		`/institute/${instId}/inventory/ingredient/search`,
	searchBrandList: (instId, keyword) =>
		`/institute/${instId}/inventory/brand/search?keyword=${keyword}`,
	registInventory: instId => `/institute/${instId}/inventory`,
	registInspectImage: instId => `/institute/${instId}/inspect/image`,
	registInventoryImage: instId => `/institute/${instId}/inventory/image`,
	lookupInventoryHistory: (instId, params) =>
		`/institute/${instId}/inventory/log?${ParamMaker.setParamUsingObject(
			params
		)}`,
	removeInventoryHistory: (instId, ids) =>
		`/institute/${instId}/inventory/log?${ParamMaker.setArrayString(
			'ids',
			ids
		)}`,
	lookupDumpList: instId => `/institute/${instId}/inventory/dump/list`,
	completeRemoveInventory: (instId, params) =>
		`/institute/${instId}/inventory/complete?${ParamMaker.setParamUsingObject(
			params
		)}`,
	restoreInventory: instId => `/institute/${instId}/inventory/restore`,
	registrationList: instId => `/institute/${instId}/inventory/registrants`,
	searchCategoryTypeField: (instId, type) =>
		`/institute/${instId}/inventory/kind/search?categoryType=${type}`,
	editInventory: instId => `/institute/${instId}/inventory`,
	qrStickerValidation: instId => `/institute/${instId}/inventory/qrSticker`,
}

const inventoryAPI = {
	getUnit: unit => axios.get(endPoint.getUnit(unit)),
	lookupInventoryList: (instId, params) =>
		axios.get(endPoint.lookupInventoryList(instId), { params: params }),
	lookupInventoryListV2: (instId, params) =>
		axios.get(endPoint.lookupInventoryListV2(instId), { params: params }),
	useItem: (instId, data) => axios.patch(endPoint.useItem(instId), data),
	lookupItemDetail: (instId, itemId) =>
		axios.get(endPoint.lookupItemDetail(instId, itemId)),
	returnItem: (instId, data) =>
		axios.patch(endPoint.returnItem(instId), data),
	deleteItem: (instId, itemIds, memo) =>
		axios.delete(endPoint.deleteItem(instId, itemIds, memo)),
	disposeItem: (instId, data) =>
		axios.patch(endPoint.disposeItem(instId), data),
	consumeItem: (instId, data) =>
		axios.patch(endPoint.consumeItem(instId), data),
	lookupInventoryAssignees: instId =>
		axios.get(endPoint.lookupInventoryAssignees(instId)),
	lookupCategory: instId => axios.get(endPoint.lookupCategory(instId)),
	divideItem: (instId, data) => axios.put(endPoint.divideItem(instId), data),
	moveStorage: (instId, data) =>
		axios.patch(endPoint.moveStorage(instId), data),
	searchProduct: (instId, params) =>
		axios.get(endPoint.searchProduct(instId), { params: params }),
	searchIngredient: (instId, params) =>
		axios.get(endPoint.searchIngredient(instId), { params: params }),
	searchBrandList: (instId, keyword) =>
		axios.get(endPoint.searchBrandList(instId, keyword)),
	registInventory: (instId, formData, registerMethod) => {
		if (registerMethod === 'AUTO_IMAGE') {
			return axios.post(endPoint.registInspectImage(instId), formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
		} else {
			return axios.post(endPoint.registInventory(instId), formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
		}
	},
	lookupInventoryHistory: (instId, params) =>
		axios.get(endPoint.lookupInventoryHistory(instId, params)),
	removeInventoryHistory: (instId, ids) =>
		axios.delete(endPoint.removeInventoryHistory(instId, ids)),
	lookupDumpList: (instId, params) =>
		axios.get(endPoint.lookupDumpList(instId), { params: params }),
	completeRemoveInventory: (instId, params) =>
		axios.delete(endPoint.completeRemoveInventory(instId, params)),
	restoreInventory: (instId, data) =>
		axios.patch(endPoint.restoreInventory(instId), data),
	lookupWaitingList: (
		instId,
		offset,
		length,
		status,
		categoriesType,
		registersId,
		startDatetime,
		endDatetime
	) => {
		console.log(
			endPoint.lookupWaitingList(
				instId,
				offset,
				length,
				status,
				categoriesType,
				registersId,
				startDatetime,
				endDatetime
			)
		)
		return axios.get(
			endPoint.lookupWaitingList(
				instId,
				offset,
				length,
				status,
				categoriesType,
				registersId,
				startDatetime,
				endDatetime
			)
		)
	},
	searchCategoryTypeField: (instId, type) =>
		axios.get(endPoint.searchCategoryTypeField(instId, type)),
	editInventory: (instId, formData) =>
		axios.put(endPoint.editInventory(instId), formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
	// 랩매니저 발행 QR Sticker 유효성 검증
	// error code : 16020 (이상한 QR임)
	// error code : 10121 (이미 사용 중임 QR임)
	qrStickerValidation: (instId, params) =>
		axios.get(endPoint.qrStickerValidation(instId), { params: params }),
}

export default inventoryAPI
